import ApiService from '@/services/api.service';
import store from '@/store';
import { PUBLIC_ROOT_API } from '@/config/app.config';
import LocalStoreService from '@/utils/local.store';
import { IdentificationDTO } from '@/models/IdentificationDTO';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';

export default class AtHomeService {
  static async saveContent(questionnaire: QuestionnaireDTO) {
    await ApiService.post(`${PUBLIC_ROOT_API}/equest/athome`, questionnaire)
      // tslint:disable-next-line: no-empty
      .then((response: any) => { 
        store.commit('setQuestionnaireValidationErrors', {});
      });
  }
  

  /**
   * Open a participant dossier
   * @param partId The participant ID
   */
  public static async identify(partId: number, birthdate: Date, suPrefix: string) {
    const requestData = {
      method: 'post',
      url: `${PUBLIC_ROOT_API}/equest/athome/identify`,
      data: {
        partId,
        birthdate,
        suPrefix
      },
    };

    return await ApiService.post(requestData.url, requestData.data)
      // tslint:disable-next-line: no-empty
      .then((response: any) => {
        store.dispatch('setIsIdentified', true);
        store.dispatch('setQuestionnaire', response.questionnaire);
        return response.data as IdentificationDTO;
      });
  }

  public static async FetchQuestionnaire() {
    const requestData = {
      method: 'get',
      url: `${PUBLIC_ROOT_API}/equest/athome`,
    };

    return await ApiService.get(requestData.url)
      // tslint:disable-next-line: no-empty
      .then((response: any) => {
        store.dispatch('setQuestionnaire', response.data);
        return response.data;
      });
  }
}
